import {
    CONNECTION_STATE_INITIAL,
    CONNECTION_STATE_CONNECTING,
    CONNECTION_STATE_CONNECTED,
    CONNECTION_STATE_STALLED,
    CONNECTION_STATE_DISCONNECTED_BY_SERVER,
    CONNECTION_STATE_RECONNECTING
} from '../constants/connectionState';

import {
    DISCONNECT,
    LOGIN_SUCCESS,
    LOGIN_NOT_ALLOWED,
    PRECONNECT,
    PRELOGIN,
    CLOSE
} from '../constants/general';

import {
    ROOM_INACTIVE
} from '../constants/rooms';

export default function connectionState(state = CONNECTION_STATE_INITIAL, action) {
    if (action.type == 'CONNECTION_STATE_CHANGE') {
        return action.state;
    }

    if (action.type == PRELOGIN) {
        return CONNECTION_STATE_CONNECTING;
    }

    if (action.type == LOGIN_SUCCESS) {
        return CONNECTION_STATE_CONNECTED;
    }

    if (action.type == LOGIN_NOT_ALLOWED || action.type == ROOM_INACTIVE) {
        return CONNECTION_STATE_STALLED;
    }

    if (action.type == DISCONNECT) {
        return CONNECTION_STATE_DISCONNECTED_BY_SERVER;
    }

    if (action.type == PRECONNECT) {
        return CONNECTION_STATE_RECONNECTING;
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/connectionState.js